// extracted by mini-css-extract-plugin
module.exports = {"root":"GithubRepoSkeleton_root__dPI7y"};